import { MeterGasOutlineIcon } from './MeterGasOutlineIcon';

/**
 * author: Google
 * id 7960EDB3-0C0D-47C8-B837-C606FEA6B524
 * name meter-gas-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/meter-gas-outline.svg
 * tags
 * - Home Automation 
 */
export const NaturalGasOutlineIcon = MeterGasOutlineIcon;
export default NaturalGasOutlineIcon